import { AccessType } from '../types';

// Helper function to display role names
export const getRoleDisplayName = (role: string): string => {
  switch (role) {
    case 'org_admin':
      return 'Admin';
    case 'user':
      return 'User';
    case 'super_admin':
      return 'Super Admin';
    default:
      return role;
  }
};

// Helper function to generate incremental IDs for org_admin users
export const getIncrementalId = (items: any[], index: number, currentUserRole?: string): string | number => {
  if (currentUserRole === 'org_admin') {
    return index + 1;
  }
  return items[index]?.user_id || items[index]?.org_id || index + 1;
};

// Helper function to get access type display with coming soon badge
export const getAccessTypeDisplay = (accessType: AccessType, currentUserRole?: string): { label: string; isComingSoon: boolean } => {
  switch (accessType) {
    case 'web':
      return { label: 'WEB', isComingSoon: false };
    case 'ide':
      return { label: 'IDE', isComingSoon: false };
    case 'security':
      return { label: 'SECURITY', isComingSoon: false };
    case 'devops':
      return { label: 'DEVOPS', isComingSoon: currentUserRole !== 'super_admin' };
    default:
      return { label: String(accessType).toUpperCase(), isComingSoon: false };
  }
};

// Helper function to check if user should see delete option
export const canDeleteUser = (currentUserRole?: string): boolean => {
  return currentUserRole === 'super_admin';
};

// Helper function to filter roles for org_admin
export const getFilteredRoles = (currentUserRole?: string): Array<{ value: string; label: string }> => {
  const allRoles = [
    { value: '', label: 'All Roles' },
    { value: 'user', label: 'User' },
    { value: 'org_admin', label: 'Organization Admin' },
    { value: 'super_admin', label: 'Super Admin' }
  ];

  if (currentUserRole === 'org_admin') {
    // Hide super admin from filter for org_admin
    return allRoles.filter(role => role.value !== 'super_admin');
  }

  return allRoles;
};

// Helper function to get pagination size options
export const getPaginationSizeOptions = (): Array<{ value: number; label: string }> => {
  return [
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' }
  ];
};
